// Module
var code = `<div data-bind="class: getRootCss(), event: { keydown: tryToZoom, mouseover: (device === 'desktop' ? null : activateZoom), mouseout: (device === 'desktop' ? null : deactivateZoom) }">
  <!-- ko if: hasFrame -->
  <div class="svd-simulator-wrapper" id="svd-simulator-wrapper" data-bind="style: { width: simulatorFrame.frameWidth + 'px', height: simulatorFrame.frameHeight + 'px' }">
    <div class="svd-simulator" data-bind="style: { width: simulatorFrame.deviceWidth + 'px', height: simulatorFrame.deviceHeight + 'px', transform: 'scale(' + simulatorFrame.scale + ') translate(-50%, -50%)' }">
      <survey-widget class="svd-simulator-content" params="model: survey"></survey-widget>
    </div>
  </div>
  <!-- /ko -->
  <!-- ko ifnot: hasFrame -->
  <survey-widget class="svd-simulator-content" params="model: survey"></survey-widget>
  <!-- /ko -->
</div>`;
// Exports
export default code;